var render = function render(){var _vm=this,_c=_vm._self._c;return _c('woot-button',{staticClass:"label--add",attrs:{"type":"button","variant":"smooth","icon":"add","size":"tiny"},on:{"click":_vm.handleClick}},[_vm._v("\n  "+_vm._s(_vm.computedLabelText)+"\n")])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }